<template>
  <div class="">
    <div v-if="!authUser">
      <button @click="signInWithGoogle" class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
        <i class="fa fa-google fa-btn"></i>Admin Sign in with Google
      </button>
      <button v-if="devBypass" @click="devSignIn" class="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded ml-1">
        Dev Admin View
      </button>
    </div>
    <div v-else>
      <button @click="signOut" class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
        <i class="fa fa-google fa-btn"></i>Sign Out
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignIn',
  methods: {
    async signInWithGoogle () {
      await this.$store.dispatch('signInWithGoogle')
      this.$router.push('/')
    },

    async signOut () {
      await this.$store.dispatch('signOut')
      this.$router.push('/')
    },

    // Renders the admin UI without Firebase auth (Google sign-in needs this
    // origin authorized in the Firebase project). UI-only: the Firestore
    // client stays unauthenticated, so writes depend on the project's rules.
    devSignIn () {
      this.$store.commit('setAuthId', 'dev-admin-bypass')
    }
  },
  computed: {
    authUser () {
      return this.$store.getters.authUser
    },
    devBypass () {
      return process.env.NODE_ENV === 'development' && process.env.VUE_APP_DEV_ADMIN_BYPASS === 'true'
    }
  }
}
</script>

<style scoped>
  button{ font-size: 10px; }

</style>
